import { render, staticRenderFns } from "./StakeButton.vue?vue&type=template&id=2c0d4ff6&scoped=true"
import script from "./StakeButton.vue?vue&type=script&lang=js"
export * from "./StakeButton.vue?vue&type=script&lang=js"
import style0 from "./StakeButton.vue?vue&type=style&index=0&id=2c0d4ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d4ff6",
  null
  
)

export default component.exports